"use client";

import React from "react";
import { useAuth } from "@/contexts/AuthContext";
import { ERoles } from "@/data/roles";

interface RoleGuardProps {
  children: React.ReactNode;
  allowedRoles: ERoles[];
  fallback?: React.ReactNode;
  onDenied?: () => void; // Added callback for denied access
}

export const RoleGuard: React.FC<RoleGuardProps> = ({ children, allowedRoles, fallback = null, onDenied }) => {
  const { user, isInRole, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  const hasRequiredRole = user && user.roles ? allowedRoles.some((role) => isInRole(role)) : false;

  if (!hasRequiredRole) {
    if (onDenied) {
      onDenied();
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default RoleGuard;
